import Component from 'components/pages/Dashboard/Dashboard';
import { buildPage } from 'utils/pageHelper';
import { GetStaticProps } from 'next/types';

export default buildPage(Component, {
  requiresAuthentication: true,
  metaData: {
    title: 'My Qmee',
    description: 'View your top surveys, cashback, deals and offers.',
  },
});

export const getStaticProps: GetStaticProps = async (context) => {
  return { props: { hideFooterCta: true } };
};
